/**
 * playersCacheTabStyles.js — StyleSheet for PlayersCacheTab.
 * Extracted verbatim from components/PlayersCacheTab.jsx (god-file decomposition).
 */

import { StyleSheet } from 'react-native';
import { uiVar } from './floodlight/uiStyleCss';
import { ADM_DISPLAY } from './floodlight/vars/admin';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: uiVar('adm-paper', '#0F172A'),
  },
  // ═══════════════════════════════════════════════════════════════════
  // Top row: 3 stat cards horizontally
  // ═══════════════════════════════════════════════════════════════════
  topCardsRow: {
    flexDirection: 'row',
    margin: 16,
    marginBottom: 0,
    gap: 12,
  },
  topCard: {
    flex: 1,
    backgroundColor: uiVar('adm-card', '#1E293B'),
    borderRadius: 12,
    padding: 16,
    maxHeight: 420, // Fixed max height so cards don't push everything down
    overflow: 'hidden',
  },
  injuryScrollContainer: {
    maxHeight: 300, // Scrollable area within the injury card
  },
  // ═══════════════════════════════════════════════════════════════════
  card: {
    backgroundColor: uiVar('adm-card', '#1E293B'),
    borderRadius: 12,
    padding: 16,
    margin: 16,
    marginBottom: 0,
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  cardTitle: { ...ADM_DISPLAY, letterSpacing: uiVar('adm-display-track', 'normal'),
    fontSize: 18,
    fontWeight: '700',
    color: uiVar('adm-ink', '#F8FAFC'),
  },
  refreshButton: {
    backgroundColor: '#10B981',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  refreshButtonDisabled: {
    backgroundColor: '#6B7280',
  },
  refreshButtonText: {
    color: uiVar('adm-ink', '#FFFFFF'),
    fontWeight: '600',
    fontSize: 14,
  },
  statsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  statBox: {
    backgroundColor: uiVar('adm-raised', '#334155'),
    borderRadius: 8,
    padding: 12,
    minWidth: 100,
    flex: 1,
    alignItems: 'center',
  },
  statNumber: {
    fontSize: 20,
    fontWeight: '700',
    color: '#10B981',
  },
  statLabel: {
    fontSize: 12,
    color: uiVar('adm-muted', '#94A3B8'),
    marginTop: 4,
  },
  leagueBreakdown: {
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#334155'),
  },
  breakdownTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: uiVar('adm-muted', '#94A3B8'),
    marginBottom: 8,
  },
  breakdownGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  breakdownItem: {
    backgroundColor: uiVar('adm-raised', '#334155'),
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  breakdownLeague: {
    fontSize: 12,
    fontWeight: '600',
    color: uiVar('adm-ink', '#F8FAFC'),
  },
  breakdownCount: {
    fontSize: 12,
    color: '#10B981',
    fontWeight: '700',
  },
  searchRow: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 12,
  },
  searchInput: {
    flex: 1,
    backgroundColor: uiVar('adm-raised', '#334155'),
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    color: uiVar('adm-ink', '#F8FAFC'),
    fontSize: 14,
  },
  searchButton: {
    backgroundColor: '#3B82F6',
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 8,
    justifyContent: 'center',
  },
  searchButtonText: {
    color: uiVar('adm-ink', '#FFFFFF'),
    fontWeight: '600',
    fontSize: 14,
  },
  leaguePills: {
    flexDirection: 'row',
    marginTop: 4,
  },
  leaguePill: {
    backgroundColor: uiVar('adm-raised', '#334155'),
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 20,
    marginRight: 8,
  },
  leaguePillActive: {
    backgroundColor: '#10B981',
  },
  leaguePillText: {
    color: uiVar('adm-muted', '#94A3B8'),
    fontSize: 13,
    fontWeight: '500',
  },
  leaguePillTextActive: {
    color: uiVar('adm-ink', '#FFFFFF'),
  },
  loadingContainer: {
    padding: 40,
    alignItems: 'center',
  },
  loadingText: {
    color: uiVar('adm-muted', '#94A3B8'),
    marginTop: 12,
  },
  errorContainer: {
    padding: 20,
    alignItems: 'center',
  },
  errorText: {
    color: '#EF4444',
    fontSize: 14,
    marginBottom: 12,
  },
  retryButton: {
    backgroundColor: '#3B82F6',
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 6,
  },
  retryButtonText: {
    color: uiVar('adm-ink', '#FFFFFF'),
    fontWeight: '600',
  },
  emptyContainer: {
    padding: 40,
    alignItems: 'center',
  },
  emptyText: {
    color: uiVar('adm-muted', '#94A3B8'),
    fontSize: 16,
    fontWeight: '500',
  },
  emptySubtext: {
    color: uiVar('adm-muted2', '#64748B'),
    fontSize: 13,
    marginTop: 4,
  },
  playersList: {
    marginTop: 8,
  },
  listControls: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    flexWrap: 'wrap',
    gap: 8,
  },
  teamsSummary: {
    fontSize: 13,
    color: uiVar('adm-muted2', '#64748B'),
  },
  expandControls: {
    flexDirection: 'row',
    gap: 8,
  },
  expandAllBtn: {
    backgroundColor: uiVar('adm-raised', '#475569'),
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  expandAllBtnText: {
    fontSize: 12,
    color: uiVar('adm-ink', '#F8FAFC'),
    fontWeight: '500',
  },
  teamGroup: {
    marginBottom: 8,
  },
  teamHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: uiVar('adm-raised', '#334155'),
    padding: 12,
    borderRadius: 8,
    gap: 8,
  },
  teamHeaderIcon: {
    fontSize: 12,
    color: '#10B981',
    width: 16,
  },
  teamHeader: {
    fontSize: 14,
    fontWeight: '700',
    color: uiVar('adm-ink', '#F8FAFC'),
    flex: 1,
  },
  teamCount: {
    fontSize: 13,
    color: '#10B981',
    fontWeight: '600',
  },
  playerRow: {
    backgroundColor: uiVar('adm-raised', '#334155'),
    borderRadius: 8,
    padding: 12,
    marginBottom: 6,
  },
  playerInfo: {
    flex: 1,
  },
  playerName: {
    fontSize: 15,
    fontWeight: '600',
    color: uiVar('adm-ink', '#F8FAFC'),
  },
  playerMeta: {
    flexDirection: 'row',
    gap: 8,
    marginTop: 4,
  },
  playerPosition: {
    fontSize: 12,
    color: '#3B82F6',
    fontWeight: '500',
  },
  playerJersey: {
    fontSize: 12,
    color: uiVar('adm-muted', '#94A3B8'),
  },
  playerLeague: {
    fontSize: 12,
    color: '#10B981',
    fontWeight: '500',
  },
  expandIcon: {
    position: 'absolute',
    right: 12,
    top: 12,
    color: uiVar('adm-muted2', '#64748B'),
    fontSize: 12,
  },
  playerDetails: {
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#475569'),
  },
  detailRow: {
    marginBottom: 6,
  },
  detailLabel: {
    color: uiVar('adm-muted', '#94A3B8'),
    fontSize: 13,
  },
  detailValue: {
    color: uiVar('adm-ink', '#F8FAFC'),
    fontSize: 13,
  },
  propsButton: {
    backgroundColor: uiVar('adm-raised', '#475569'),
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 6,
    marginTop: 12,
    alignItems: 'center',
  },
  propsButtonText: {
    color: uiVar('adm-muted', '#94A3B8'),
    fontSize: 13,
    fontWeight: '500',
  },
});
